module.exports = __webpack_public_path__ + "static/media/yellow2.fb67c030.png";